import { Link } from 'react-router-dom';
import { seoFeatureArticles, comparisonArticles } from '@/mocks/homeData';

const featureImages: Record<string, string> = {
  'feature-guide-01': 'https://readdy.ai/api/search-image?query=Organized%20laptop%20screen%20displaying%20clean%20spreadsheet%20dashboard%20with%20product%20category%20cards%20and%20filter%20tabs%20on%20light%20wooden%20desk%20warm%20afternoon%20natural%20light%20from%20side%20window%20modern%20SaaS%20interface%20aesthetic%20with%20soft%20bokeh%20background%20professional%20editorial%20composition&width=800&height=500&seq=feature-guide-v2-4r7t&orientation=landscape',
  'feature-compare-02': 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20interface%20between%20two%20product%20databases%20displayed%20on%20tablet%20screen%20on%20white%20marble%20surface%20minimal%20modern%20UI%20design%20showing%20category%20metrics%20and%20rating%20indicators%20clean%20bright%20studio%20lighting%20professional%20tech%20editorial%20photography&width=800&height=500&seq=feature-kakobuy-v2-5s8u&orientation=landscape',
  'feature-safety-03': 'https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20product%20quality%20verification%20with%20magnifying%20glass%20over%20product%20cards%20and%20checklist%20icons%20on%20clean%20off%20white%20desk%20natural%20daylight%20from%20above%20creating%20soft%20even%20illumination%20modern%20professional%20editorial%20style%20with%20geometric%20elements&width=800&height=500&seq=feature-cssbuy-v2-6t9v&orientation=landscape',
  'feature-superbuy-04': 'https://readdy.ai/api/search-image?query=Modern%20dual%20monitor%20workspace%20setup%20displaying%20category%20grids%20and%20product%20listings%20in%20spreadsheet%20format%20on%20warm%20beige%20desk%20surface%20morning%20sunlight%20creating%20gentle%20highlights%20clean%20productive%20atmosphere%20professional%20editorial%20photography%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=feature-superbuy-v2-7u0w&orientation=landscape',
  'feature-compare-05': 'https://readdy.ai/api/search-image?query=Creative%20overhead%20flat%20lay%20of%20five%20smartphones%20each%20displaying%20different%20spreadsheet%20platform%20interfaces%20arranged%20in%20circle%20on%20light%20grey%20textured%20surface%20soft%20diffused%20overhead%20lighting%20modern%20editorial%20product%20photography%20with%20consistent%20spacing&width=800&height=500&seq=feature-platforms-v2-8v1x&orientation=landscape',
  'feature-safety-06': 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20composition%20of%20security%20icons%20shield%20lock%20and%20checkmark%20symbols%20alongside%20product%20cards%20on%20warm%20paper%20texture%20background%20soft%20natural%20lighting%20from%20window%20creating%20gentle%20shadows%20editorial%20infographic%20style%20photography&width=800&height=500&seq=feature-safety-v2-9w2y&orientation=landscape',
};

export default function SEOFeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium font-label mb-4">
              SEO Research Hub
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Your Independent Spreadsheet<br />Research Platform
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md lg:text-right">
            We are an independent research platform — not affiliated with any shopping agent.
            Our mission is to organize and compare spreadsheet resources across all major platforms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoFeatureArticles.map((article) => (
            <Link
              key={article.seq}
              to={article.link}
              className="group rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden transition-all duration-300 hover:border-primary-200"
            >
              <div className="w-full h-44 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={featureImages[article.seq]}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {article.subtitle}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-primary-600">
                  <span>Read Article</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
          {comparisonArticles.map((article) => (
            <Link
              key={article.seq}
              to={article.link}
              className="group rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden transition-all duration-300 hover:border-accent-200"
            >
              <div className="w-full h-44 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={featureImages[article.seq]}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 group-hover:text-accent-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {article.subtitle}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-accent-600">
                  <span>Explore Now</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}